import { FC, useCallback, ChangeEvent, memo } from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PriceInput from 'components/PriceInput';

import { MarkupType } from '__generated__/PackageEditMain_package.graphql';

type ControlProps = {
  type: MarkupType | null;
  valueAdult: number | string;
  valueChild: number | string;
  onTypeChange: (type: MarkupType) => void;
  onValueChange: (value: string, isAdult: boolean) => void;
};

const Control: FC<ControlProps> = props => {
  const { type, valueAdult, valueChild, onTypeChange, onValueChange } = props;

  const handleTypeChange = useCallback(
    (type: MarkupType) => () => {
      onTypeChange(type);
    },
    [onTypeChange]
  );

  const handleValueChange = useCallback(
    (isAdult: boolean) => (event: ChangeEvent<HTMLInputElement>) => {
      onValueChange(event.currentTarget.value, isAdult);
    },
    [onValueChange]
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="caption">Antkainis</Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          checked={type === 'STANDARD'}
          control={<Radio color="primary" />}
          label="Standartinis"
          onClick={handleTypeChange('STANDARD')}
        />
      </Grid>

      <Grid item xs={3}>
        <FormControlLabel
          checked={type === 'FIXED'}
          control={<Radio color="primary" />}
          label="Fiksuotas"
          onClick={handleTypeChange('FIXED')}
        />
      </Grid>

      <Grid item xs={9}>
        <PriceInput
          id="fixedValueAdult"
          variant="standard"
          label="Suaugusiam"
          value={type === 'FIXED' && valueAdult ? valueAdult : ''}
          disabled={!type || type === 'STANDARD'}
          onChange={handleValueChange(true)}
          sx={{ mr: 1, mt: '-10px' }}
        />

        <PriceInput
          id="fixedValueChild"
          variant="standard"
          label="Vaikui"
          value={type === 'FIXED' && valueChild ? valueChild : ''}
          disabled={!type || type === 'STANDARD'}
          onChange={handleValueChange(false)}
          sx={{ mt: '-10px' }}
        />
      </Grid>
    </Grid>
  );
};

export default memo(Control);
